import { Component, HostListener, OnInit } from '@angular/core';
import { TrackingService } from '../../tracking.service';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent implements OnInit {

  toggleButton: boolean = true;
  valForm: FormGroup;
  trackingDetails: Object;
  trackingingDestination: any;
  trackingingWeight: any;
  trackingLocation: any;
  track: any;
  track1: any;
  track2: any;
  spin: boolean = false
  errMsg: string;
  view: boolean = false
  windowWidth;
  trackingingPcs: any;
  invoice_no: any;
  track_number: any;
  constructor(private service: TrackingService, private fb: FormBuilder, public route: ActivatedRoute) {
    route.queryParams.subscribe(
      params => {
        this.track_number = params['no']
        this.gethHttp(this.track_number)
      })

    this.valForm = this.fb.group({
      id: [null]
    })
    this.windowWidth = window.innerWidth;
    console.log(this.track_number)

    // this.gethHttp("SH10001")
  }
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      console.log('Route parameter:', id);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    console.log("fsd")
    this.getIconStyle()
    this.getLineStyle()
  }
  status: string = 'Destination_Arrived';


  getLineStyle() {
    let lineStyle = {};
    console.log(this.status)
    if (this.windowWidth > 1200) {
      switch (this.status) {
        case 'HAWB Booked At Origin':
          lineStyle = {
            'left': '7%',
            'right': '90%'
          };
          break;

        case 'departed_to':
          lineStyle = {
            'left': '7%',
            'right': '75%'
          };
          break;
        case 'FORWARDED TO SCANNING':
          lineStyle = {
            'left': '7%',
            'right': '75%'
          };
          break;

        case 'in_transit':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;

        case 'reaching soon':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;

        case 'Ready for departure':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;


        case 'Under Custom Clearance':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;
        //added

        case 'waiting_for_clearance':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;

        case 'Custom_cleared':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;
        case 'Shippment Cleared':
          lineStyle = {
            'left': '7%',
            'right': '42%'
          };
          break;

        case 'Destination_Arrived':
          lineStyle = {
            'left': '7%',
            'right': '42%'
          };
          break;

        case 'in port tdk':
          lineStyle = {
            'left': '7%',
            'right': '42%'
          };
          break;



        case 'tdk port clearance':
          lineStyle = {
            'left': '7%',
            'right': '42%'
          };
          break;



        case 'Arrived At Destination Port':
          lineStyle = {
            'left': '7%',
            'right': '42%'
          };
          break;


        case 'Out_For_Delivery':
          lineStyle = {
            'left': '7%',
            'right': '25%'
          };
          break;
        case 'out_for_Delivery':
          lineStyle = {
            'left': '7%',
            'right': '25%'
          };
          break;
        case 'OUT FOR DELIVERY':
          lineStyle = {
            'left': '7%',
            'right': '25%'
          };
          break;
        //Taken_for_Delivery

        case 'DELIVERED':
          lineStyle = {
            'left': '7%',
            'right': '8%'
          };
          break;
        
          default:
            lineStyle = {
              'left': '7%',
              'right': '58%'
            };
            break;
        
      }
    }
    else if (this.windowWidth > 767) {
      switch (this.status) {
        case 'HAWB Booked At Origin':
          lineStyle = {
            'left': '7%',
            'right': '90%'
          };
          break;

        case 'departed_to':
          lineStyle = {
            'left': '7%',
            'right': '75%'
          };
          break;
        case 'FORWARDED TO SCANNING':
          lineStyle = {
            'left': '7%',
            'right': '75%'
          };
          break;

        case 'in_transit':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;
        case 'reaching soon':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;


        case 'Ready for departure':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;

        case 'Under Custom Clearance':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;

        case 'waiting_for_clearance':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;

        case 'Custom_cleared':
          lineStyle = {
            'left': '7%',
            'right': '58%'
          };
          break;
        //added
        case 'Shippment Cleared':
          lineStyle = {
            'left': '7%',
            'right': '40%'
          };
          break;

        case 'Destination_Arrived':
          lineStyle = {
            'left': '7%',
            'right': '40%'
          };
          break;

        case 'in port tdk':
          lineStyle = {
            'left': '7%',
            'right': '40%'
          };
          break;



        case 'tdk port clearance':
          lineStyle = {
            'left': '7%',
            'right': '40%'
          };
          break;


        case 'Arrived At Destination Port':
          lineStyle = {
            'left': '7%',
            'right': '40%'
          };
          break;


        case 'Out_For_Delivery':
          lineStyle = {
            'left': '7%',
            'right': '25%'
          };
          break;
        case 'out_for_Delivery':
          lineStyle = {
            'left': '7%',
            'right': '25%'
          };
          break;
        case 'OUT FOR DELIVERY':
          lineStyle = {
            'left': '7%',
            'right': '25%'
          };
          break;
        //Taken_for_Delivery

        case 'DELIVERED':
          lineStyle = {
            'left': '7%',
            'right': '5%'
          };
          break;

          default:
            lineStyle = {
              'left': '7%',
              'right': '58%'
            };
            break;
      }
    }
    return lineStyle;
  }

  getIconStyle() {
    let iconStyle = {};
    let lineWidth = 90; // Adjust this value based on the width of your blue line
    let iconWidth = 20; // Adjust this value based on the width of your icon

    if (this.windowWidth > 1200) {
      switch (this.status) {
        case 'HAWB Booked At Origin':
          iconStyle = {
            'left': '8%',
            'top': '-35%'

          };
          break;
        case 'departed_to':
          iconStyle = {
            'right': '72%',
            'top': '-35%'
          };
          break;
        case 'FORWARDED TO SCANNING':
          iconStyle = {
            'right': '72%',
            'top': '-35%'
          };
          break;

        case 'in_transit':
          iconStyle = {
            'right': '54%',
            'top': '-35%'
          }
          break;

        case 'reaching soon':
          iconStyle = {
            'right': '54%',
            'top': '-35%'
          }
          break;


        case 'Ready for departure':
          iconStyle = {
            'right': '54%',
            'top': '-35%'
          }
          break;


        case 'Under Custom Clearance':
          iconStyle = {
            'right': '54%',
            'top': '-35%'
          }
          break;
        //added


        case 'waiting_for_clearance':
          iconStyle = {
            'right': '54%',
            'top': '-35%'
          }
          break;

        case 'Custom_cleared':
          iconStyle = {
            'right': '54%',
            'top': '-35%'
          }
          break;
        case 'Shippment Cleared':
          iconStyle = {
            'right': '37%',
            'top': '-35%'
          }
          break;
        case 'Destination_Arrived':
          iconStyle = {
            'right': '37%',
            'top': '-35%'
          };
          break;

        case 'in port tdk':
          iconStyle = {
            'right': '37%',
            'top': '-35%'
          };
          break;


        case 'tdk port clearance':
          iconStyle = {
            'right': '37%',
            'top': '-35%'
          };
          break;


        case 'Arrived At Destination Port':
          iconStyle = {
            'right': '37%',
            'top': '-35%'
          };
          break;



        case 'Out_For_Delivery':
          iconStyle = {
            'right': '21%',
            'top': '-35%'
          };
          break;
        case 'out_for_Delivery':
          iconStyle = {
            'right': '21%',
            'top': '-35%'
          };
          break;

        case 'OUT FOR DELIVERY':
          iconStyle = {
            'right': '21%',
            'top': '-35%'
          };
          break;
        //Taken_for_Delivery
        case 'DELIVERED':
          iconStyle = {
            'right': '4%',
            'top': '-35%'
          };
          break;

          default:
            iconStyle = {
              'right': '54%',
              'top': '-35%'
            }
            break;
      }

    } else if (this.windowWidth > 768) {
      switch (this.status) {
        case 'HAWB Booked At Origin':
          iconStyle = {
            'left': '9%',
            'top': '-2%'

          };
          break;
        case 'departed_to':
          iconStyle = {
            'right': '72%',
            'top': '-2%'
          };
          break;
        case 'FORWARDED TO SCANNING':
          iconStyle = {
            'right': '72%',
            'top': '-2%'
          };
          break;

        case 'in_transit':
          iconStyle = {
            'right': '56%',
            'top': '-2%'
          }
          break;

        case 'reaching soon':
          iconStyle = {
            'right': '56%',
            'top': '-2%'
          }
          break;


        case 'Ready for departure':
          iconStyle = {
            'right': '56%',
            'top': '-2%'
          }
          break;

        case 'Under Custom Clearance':
          iconStyle = {
            'right': '56%',
            'top': '-2%'
          }
          break;


        case 'Custom_cleared':
          iconStyle = {
            'right': '56%',
            'top': '-2%'
          }
          break;
        //added


        case 'waiting_for_clearance':
          iconStyle = {
            'right': '56%',
            'top': '-2%'
          }
          break;
        case 'Shippment Cleared':
          iconStyle = {
            'right': '37%',
            'top': '-2%'
          }
          break;
        case 'Destination_Arrived':
          iconStyle = {
            'right': '37%',
            'top': '-2%'
          };
          break;

        case 'in port tdk':
          iconStyle = {
            'right': '37%',
            'top': '-2%'
          };
          break;



        case 'tdk port clearance':
          iconStyle = {
            'right': '37%',
            'top': '-2%'
          };
          break;


        case 'Arrived At Destination Port':
          iconStyle = {
            'right': '37%',
            'top': '-2%'
          };
          break;


        case 'Out_For_Delivery':
          iconStyle = {
            'right': '20%',
            'top': '-2%'
          };
          break;
        case 'OUT FOR DELIVERY':
          iconStyle = {
            'right': '20%',
            'top': '-2%'
          };
          break;
        case 'out_for_Delivery':
          iconStyle = {
            'right': '20%',
            'top': '-2%'
          };
          break;
        //Taken_for_Delivery
        case 'DELIVERED':
          iconStyle = {
            'right': '2.5%',
            'top': '-2%'
          };
          break;
        
          default:
            iconStyle = {
              'right': '56%',
              'top': '-2%'
            }
            break;
      }
    }
    return iconStyle;
  }
  invoicenumber
  CurrentStatus123
  trackingLocation1
  ShipmentNo
  remarks1
  remarks2
  invoiceDate
  gethHttp(id) {
    this.spin = true
    this.service.getTracking(id).subscribe(data => {
      if (data['code'] == "200") {
        this.spin = false
        this.view = true
        this.errMsg = ""
        this.track1 = data['data']['0'];
        this.track2 = data['data']['status_history']
        this.invoicenumber = data['data'][0][0].invoice_no;
        this.invoiceDate = data['data'][0][0].Transit_Date;
        this.ShipmentNo = data['data'][0][0].shipment_no;

        this.CurrentStatus123 = data['data'][0][0].Ctn_Status;
        this.trackingDetails = data['data'][0][0].org_branch;
        this.trackingingDestination = data['data'][0][0].des_country;
        this.trackingingWeight = data['data'][0][0].total_weight;
        this.trackingingPcs = data['data'][0][0].total_carton;
this.remarks1 = data['data'][0][0].tracking_remarks ? data['data'][0][0].tracking_remarks: "";
        this.remarks2  = data['data']['status_history'][0].track_status
        this.trackingLocation1 = this.remarks1 == this.remarks2 ? this.remarks1 : this.remarks1 + ' - '+ this.remarks2
        // this.trackingLocation1 = data['data']['status_history'][0].track_status +' - '+ this.remarks1;
        // this.remarks1 = data['data'][0][0].tracking_remarks ? data['data'][0][0].tracking_remarks : "";
        // this.trackingLocation1 = data['data']['status_history'][0].track_status + ' - ' + this.remarks1;

        this.trackingLocation = data['data'][0][0].Ctn_Status + ' TO ' + data['data'][0][0].Current_Location;
        if(data['data'][0][0].Ctn_Status == 'Out_For_Next_Station' && data['data']['status_history'][0].Ctn_Status != "DELIVERED" && data['data']['status_history'][0].Ctn_Status != "out_for_Delivery" ){
        // if (false) {
          this.status = "in_transit"
        }
        else {
          this.status = data['data']['status_history'][0].Ctn_Status
        }
      }
      else if (data['code'] == "300") {
        this.spin = false
        this.view = true
        this.errMsg = ""
        this.track1 = data['data']['0'];
        this.track2 = data['data']['status_history']
        this.trackingDetails = data['data']['api']['response'][0].orgin;
        this.trackingingDestination = data['data']['api']['response'][0].state;
        this.trackingingWeight = data['data']['api']['response'][0].weight;
        this.trackingingPcs = data['data']['api']['response'][0].totalPieces;
        this.trackingLocation = data['data']['api']['response'][0]['trackingStatusData'][0].trackingStatus + ' At ' + data['data']['api']['response'][0]['trackingStatusData'][0].updationDate;
        // if(data['data'][0][0].Ctn_Status == 'Out_For_Next_Station')
        // {
        this.status = "in_transit"
        // }
        // else
        // {
        //   this.status = data['data'][0][0].Ctn_Status
        // }
      }
      else {
        this.spin = false
        this.view = false
        this.errMsg = "Invalid Number :("
      }
    },
      error => {
      }
    )

  }

  toggle() {
    this.toggleButton = !this.toggleButton;
  }
  podUrl=""
  DownloadPod(){
    // window.open("http://45.118.162.26:8080/Asset/pranave_delivery_app_image/"+this.valForm.value.id+"c1-pod.jpg")
   const podUrl={
    filePathUrl:"http://45.118.162.26:8080/Asset/pranave_delivery_app_image/"+this.valForm.value.id+"c1-pod.jpg"
   }
    this.service.getPodImageBase64String(podUrl).subscribe(data=>{
      this.podUrl=String("data:image/jpeg;base64,"+data['data'][0])
    })   
   $('#imageModal').modal('show');

  }
  openModal(): void {
    $('#imageModal').modal('show');
  }
}